import * as React from 'react';
import { Button, NiceModal, useNiceModal } from '@castlery/fortress';
import { selectPreferredOptions } from '@castlery/modules-product-domain';
import { addToCartCommand } from '@castlery/modules-product-services';
import { useAppDispatch, useAppSelector } from '@castlery/shared-redux-store';
import { useAsyncFn } from 'react-use';
import { trackOfflineAtc, trackOfflineAtcClick } from '@castlery/modules-tracking-services';

export const ATCButton = ({ disabled, loading }: { disabled: boolean; loading: boolean }) => {
  const dispatch = useAppDispatch();
  // eslint-disable-next-line
  const [modal, contextHolder] = useNiceModal();
  const [open, setOpen] = React.useState(false);

  const trackEvents = async () => {
    await dispatch(trackOfflineAtcClick());
    await dispatch(trackOfflineAtc());
  };

  const [{ loading: ATCLoading }, addToOrder] = useAsyncFn(async () => {
    try {
      await dispatch(addToCartCommand()).unwrap();
    } catch (error: Error | any) {
      // modal.danger({
      //   title: 'Oops! Something went wrong',
      //   content: JSON.stringify(error?.message || error),
      // });
    }
    await trackEvents();
  });
  const { preferred_stock_location_id, preferred_self_collection } = useAppSelector(selectPreferredOptions);
  const handleAddToCart = async () => {
    if (preferred_stock_location_id && !preferred_self_collection) {
      setOpen(true);
    } else {
      await addToOrder();
    }
  };
  return (
    <>
      <Button disabled={disabled} loading={loading || ATCLoading} fullWidth size="lg" onClick={handleAddToCart}>
        {!disabled ? 'Add To Cart' : 'Out of Stock'}
      </Button>
      <NiceModal
        title={'Do you confirm that this item will be fulfilled by delivery from Showroom?'}
        open={open}
        onClose={() => setOpen(false)}
        onConfirm={addToOrder}
      />
      {contextHolder}
    </>
  );
};
